import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {animate, sequence, style, transition, trigger} from "@angular/animations";

import {MapService} from "@commons/services/map/map/map.service";

import {BaseComponent} from "@shared/components/base-component";
import {NewNavigationService} from '@shared/services/new-navigation.service';

import {MapLayerType} from '@src/app/map/map-layers';

import {MapPanelService} from "@map-panel/services/map-panel.service";
import {PermissionService} from "@shared/services/permission.service";
import {AuthenticationService} from "@shared/services/authentication/authentication.service";
import {take} from "rxjs";

@Component({
  selector: 'mp-map-panel',
  templateUrl: './map-panel.component.html',
  styleUrls: ['./map-panel.component.scss'],
  animations: [
    trigger('openClose', [
      transition(":enter", [style({transform: 'translateX(120px)'}), animate('0.1s')]),
      transition(":leave", [sequence([style({
        right: '0px',
        'z-index': 0
      }), animate('0.1s', style({right: '-120px'}))])]),
    ])
  ]
})
export class MapPanelComponent extends BaseComponent implements OnInit, OnDestroy {

  @Input() isVisible = false;

  isGoogleMapsVisible = this.permissionService.hasClientSelection();

  get isEmapaSelected(): boolean {
    return this.mapService.currentMapLayerType === MapLayerType.emapa;
  }

  get isOpenStreetSelected(): boolean {
    return this.mapService.currentMapLayerType === MapLayerType.osm;
  }

  // get isOpenStreetTransportSelected(): boolean {
  //   return this.mapService.currentMapLayerType === MapLayerType.osmTransport;
  // }

  get isGoogleMapsSelected(): boolean {
    return this.mapService.currentMapLayerType === MapLayerType.googleRoadmap;
  }

  get isGoogleSatelliteSelected(): boolean {
    return this.mapService.currentMapLayerType === MapLayerType.googleHybrid;
  }

  constructor(
    private newNavigationService: NewNavigationService,
    private mapService: MapService,
    private mapPanelService: MapPanelService,
    private permissionService: PermissionService,
    private authenticationService: AuthenticationService
  ) {
    super();
    this.setIsGoogleMapsVisible();
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  ngOnInit(): void {
  }

  onClosePanel() {
    this.mapPanelService.isMapPanelVisibleSubject.next(false);
  }

  onSetEmapa() {
    this.mapService.setMapLayer(MapLayerType.emapa);
  }

  onSetOpenStreet() {
    this.mapService.setMapLayer(MapLayerType.osm);
  }

  // onSetOpenStreetTransport() {
  //   this.mapService.setMapLayer(MapLayerType.osmTransport);
  // }

  onSetGoogleRoadmap() {
    this.mapService.setMapLayer(MapLayerType.googleRoadmap);
  }

  onSetGoogleHybrid() {
    this.mapService.setMapLayer(MapLayerType.googleHybrid);
  }

  private setIsGoogleMapsVisible() {
      this.authenticationService.isAuthenticated$.pipe(take(1)).subscribe(isFinished => {
        if (isFinished) {
          this.isGoogleMapsVisible = this.authenticationService.isTekomUser;
        }
      });
  }
}
